import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'iconoir-react';

interface StorageOverageBlockedModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const StorageOverageBlockedModal: React.FC<StorageOverageBlockedModalProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) {
    return null;
  }

  const goTo = (tab: 'documents' | 'overages') => {
    onClose();
    navigate('/account', { state: { activeTab: tab } });
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>
          <Lock width={18} height={18} strokeWidth={2} style={{ verticalAlign: 'middle', marginRight: 8 }} />
          Espace de stockage insuffisant
        </h2>

        <p>
          L'ajout de ce fichier dépasserait votre capacité de stockage disponible.
        </p>

        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={() => goTo('documents')}>
            Gérer mes fichiers
          </button>

          <button className="btn btn-primary" onClick={() => goTo('overages')}>
            Ajouter du stockage
          </button>

          <button className="btn btn-secondary" onClick={onClose}>
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};
